import React from 'react'

function GroupActivityButton({onClick,className, disabled, padding={padding:'5px 10px'},width, backgroundColor, border, color,children, borderRadius, fontWeight,toggle, target}) {
  return (
    <button className={className} onClick={onClick} style={{backgroundColor, border, color,padding, width, borderRadius, fontWeight}} data-bs-toggle={toggle}
    data-bs-target={target} disabled={disabled}>{children}</button>
  )
}

export default GroupActivityButton